module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/SBI SimplySAVE Card.823af034.png";